import { sis_thangdiem } from './../../../models/response/so-diem/sis_thangdiem';
import { eThangDiemActionTypeIds } from './../../action-types/so-diem/IThangDiemActions';
import { BaseAction } from "../IBaseActionResult"

export const thangDiemActions = {
    loadStart: () => BaseAction(undefined, eThangDiemActionTypeIds.LOAD_START),
    loadSuccess: (respone: sis_thangdiem[]) => BaseAction(respone, eThangDiemActionTypeIds.LOAD_SUCCESS),
    loadError: (message: string) => BaseAction(message, eThangDiemActionTypeIds.LOAD_ERROR)
}